import React from 'react';

// Styles & Assets
import styles from './AlertRulesView.module.css';

// Languages
import { useTranslation } from 'react-i18next';

// Interfaces
import { IAlertRule } from '../../../interfaces/Score';
interface Props {
    alerts: IAlertRule[]
}

const AlertRulesView: React.FC<Props> = ({ alerts }) => {

    const { t } = useTranslation();

    return (
        <>{alerts.length > 0 &&
            <div className={styles.container}>
                <h2 className='dialogSubTitle'>{t('alerts')}</h2>
                <div className={styles.alertsContainer}>
                    {alerts.map(alert =>
                        <div key={alert.id} className={styles.alertContainer}>
                            <p>- {t('if_value_of')}</p>
                            <p className={styles.mediumText}>{alert.inquiry_question_id ? alert.inquiry_question_name : t('global_value')}</p>
                            <p>{alert.check_before ? t('varies') : t('is')}</p>
                            <p className={styles.mediumText}>{alert.comparison}</p>
                            <p>{t('than')}</p>
                            <p className={styles.mediumText}>{alert.value}</p>
                            {alert.consecutive !== undefined && alert.consecutive > 1 &&
                                <>
                                    <p>{t('for')}</p>
                                    <p className={styles.mediumText}>{alert.consecutive}</p>
                                    <p>{t('polls_in_a_row')}</p>
                                </>
                            }
                        </div>
                    )}
                </div>
            </div>
        }</>
    );
};

export default AlertRulesView;